import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { AiFillStar } from "react-icons/ai";
import { MenuCard } from "../menu/MenuCard";
import { ListItem } from "../menu/ListItem";
import { Input } from "../shared/Input";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { UiConstants } from "../../data/UiConstants";
const ListView = styled(MenuCard).withConfig({
  displayName: "ModuleToPlayListView__ListView",
  componentId: "sc-1lnq5n3-0"
})(["grid-column-start:1;display:grid;overflow-y:scroll;max-height:200px;"]);
const ContentListItem = styled(ListItem).withConfig({
  displayName: "ModuleToPlayListView__ContentListItem",
  componentId: "sc-1lnq5n3-1"
})([":hover{cursor:default;}&.disabled{color:", ";background-color:", ";pointer-events:none;cursor:default;}"], UiConstants.COLOR_DISABLED_SELECTION_HIGHLIGHT, UiConstants.COLOR_DISABLED);
const ToolBar = styled.div.withConfig({
  displayName: "ModuleToPlayListView__ToolBar",
  componentId: "sc-1lnq5n3-2"
})(["min-height:30px;"]);
const ListFilterContainer = styled.span.withConfig({
  displayName: "ModuleToPlayListView__ListFilterContainer",
  componentId: "sc-1lnq5n3-3"
})(["float:right;"]);
export const ModulesToPlayListView = observer(({
  playableModules,
  modulesToPlay,
  addModuleToPlay,
  removeModuleToPlay,
  showFilter
}) => {
  const {
    t
  } = useTranslation();
  const [filterText, setFilterText] = useState("");

  const getItemName = module => module ? module.name : "[ERROR: Module not found]";

  const getItemId = module => module ? module.$modelId : "";

  const isItemSelected = id => {
    return modulesToPlay.includes(id);
  };

  const findConflictingModules = module => {
    if (module.usedGates.length == 0) return [];
    const conflictingModules = [];

    for (const moduleToPlayId of modulesToPlay) {
      if (moduleToPlayId == getItemId(module)) continue;
      const moduleToPlay = playableModules.find(module => module.$modelId === moduleToPlayId);
      if (!moduleToPlay) continue;

      for (const gate of moduleToPlay.usedGates) {
        if (module.usedGates.includes(gate)) {
          conflictingModules.push(moduleToPlay.name);
          break;
        }
      }
    }

    return conflictingModules;
  };

  const toggleItemSelection = id => {
    if (isItemSelected(id)) {
      removeModuleToPlay(id);
    } else {
      addModuleToPlay(id);
    }
  };

  const filteredItems = () => {
    // case-insensitive search
    return playableModules.filter(item => item.mayBePlayedInWorkshops).filter(item => {
      const itemName = getItemName(item);
      const searchText = filterText.toLowerCase();
      return itemName.includes(searchText);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, showFilter && /*#__PURE__*/React.createElement(ToolBar, null, /*#__PURE__*/React.createElement(ListFilterContainer, null, t("management.filter"), ": ", /*#__PURE__*/React.createElement(Input, {
    value: filterText,
    onChange: ({
      target
    }) => setFilterText(target.value)
  }))), /*#__PURE__*/React.createElement(ListView, null, filteredItems().map(item => {
    const conflictingModules = findConflictingModules(item);
    const disabled = conflictingModules.length > 0 && !isItemSelected(getItemId(item));
    return /*#__PURE__*/React.createElement(ContentListItem, {
      key: getItemId(item),
      className: `${isItemSelected(getItemId(item)) ? "selected" : ""} 
                        ${disabled ? "disabled " : ""}`,
      onClick: () => toggleItemSelection(getItemId(item))
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: isItemSelected(getItemId(item)),
      disabled: disabled,
      onChange: () => {}
    }), (item ? item.highlighted : false) ? /*#__PURE__*/React.createElement("span", null, " ", /*#__PURE__*/React.createElement(AiFillStar, null)) : '', " " + getItemName(item), disabled && ` (${t("management.module_conflict")}${conflictingModules.map(n => " " + n)})`);
  })));
});